import {
  Box,
  Chip,
  Grid,
  Hidden,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { format, parseISO } from 'date-fns';
import useWindowDimensions from 'customHooks/DimensionHook';

const CourseDescription = ({ data, userDate }) => {
  const { width } = useWindowDimensions();
  const classes = useStyles();
  const [dateNow, setDateNow] = React.useState(
    new Date().toLocaleDateString('pt-BR')
  );  

  let formatted = '';
  let enroll = ''

  if (userDate?.length > 0 && userDate[0]?.finished_at) {
    formatted = format(parseISO(userDate[0].finished_at), 'dd/MM/yyyy');
    enroll = (userDate[0].id).split('-').slice(0, 2).join('-')
  }

  return (
    <Box className={classes.root}>
    <Box className={classes.completionCard}>
      <Grid container alignItems="center" spacing={2} >
        <Grid item xs={12} md={10} >
          <Typography variant="h6" className={classes.completionTitle}>
            {data?.name}
          </Typography>
          <Typography className={classes.completionText}>
            <strong>Nome:</strong> {userDate?.[0]?.user.name}
          </Typography>
          <Typography className={classes.completionText}>
          <strong>Data de Conclusão:</strong> {formatted}
          </Typography>
          <Typography className={classes.completionText}>
            <strong>Matrícula:</strong> {enroll}
          </Typography>
          <Typography className={classes.completionText}>
           <strong>Data da verificação:</strong> {dateNow}
          </Typography>
          <Typography className={classes.completionText}>
           <strong>Status:</strong> Concluído ✅
          </Typography>
        </Grid>
      </Grid>
    </Box>  
  </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(6),
    marginLeft: theme.spacing(2),
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  mobileRoot: {
    paddingTop: theme.spacing(6),
    paddingLeft: theme.spacing(2),
  },
  titleGrid: {
    display: 'flex',
    justifyContent: 'center',
  },
  courseTitle: {
    fontSize: theme.typography.h2.fontSize,
    lineHeight: '100%',
  },
  containerSpacing: {
    marginTop: theme.spacing(2),
  },
  lastChip: {
    marginLeft: theme.spacing(4),
  },
  overflowDescription: {
    '& p': {
      paddingRight: 10,
    },
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#696969',
      borderRadius: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#b0b0b0',
      borderRadius: '8px',
   }
  },
  detailsContainerSpacing: {
    marginTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  courseDescription: {
    color: theme.palette.default.contrastText,
    '& span': {
      '& p': {
        marginBottom: theme.spacing(1),
        '& span': {
          color: '#fff !important',
          fontSize: '.9rem !important',
          fontFamily: 'Montserrat !important',
          backgroundColor: 'transparent !important',
        }
      }
    }
  },
  gridImage: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
      marginRight: '18%',
    },
  },
  logo: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    maxWidth: 262,
    maxHeight: 152,
    [theme.breakpoints.down('sm')]: {
      maxWidth: 300,
      maxHeight: 150,
      paddingRight: theme.spacing(2)
    }
  },
  [theme.breakpoints.up('md')]: {
    overflowDescription: {
      overflow: 'auto',
      height: 135,
      marginTop: 11,
      padding: '0 10px !important',
      '& p': {
        paddingRight: 5,
      }
    },
  },

  completionCard: {
    backgroundColor: '#f5f5f5',
    borderRadius: '12px',
    width: '600px',
    maxWidth: '600px',
    padding: theme.spacing(4),
    maxHeight: 250,
    marginBottom: '24px',
    marginRight: 'auto', 
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      maxWidth: '90vw', 
      marginLeft: -80
    },
  },
  
  completionTitle: {
    fontSize: '1.4rem',
    marginBottom: 20,
    marginRight: -20,
    fontWeight: 600,
    marginBottom: '12px',
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  },
  
  completionText: {
    fontSize: '1rem',
    marginBottom: '8px',
    color: '#555',
  },
  
  completionImageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  
  completionImage: {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '50%',
    border: '2px solid #4caf50',
  },

  subBox: {
    margin:0,
      [theme.breakpoints.down('sm')]: {
        marginLeft: -80,
      },
    }
}));

export default CourseDescription;
